import { render, staticRenderFns } from "./for-goods-manage-add.vue?vue&type=template&id=932fab1c&scoped=true"
import script from "./for-goods-manage-add.vue?vue&type=script&lang=js"
export * from "./for-goods-manage-add.vue?vue&type=script&lang=js"
import style0 from "./for-goods-manage-add.vue?vue&type=style&index=0&id=932fab1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932fab1c",
  null
  
)

export default component.exports